// --- generate
// generate a random UUID, giving sane defaults

export default function generate ( options = {}) {
    const {
        uuid = "",
        digits = 8,
        seed = new Date()
    } = options

    let generatedUUID = uuid

    function generator ( i ) {
        if ( i === 8 || i === 13 || i === 18 || i === 23 ) return "-"

        if ( i === 14 ) return "4" // UUID version flag

        if ( i === 19 ) return "8" // Can be "8", "9", "A" or "B"

        return Math.floor( Math.random( seed ) * 16 ).toString( 16 )
    }

    for ( let i = 0; i < digits; i++ ) {
        generatedUUID += generator( i )
    }

    return generatedUUID
}